import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import './index.css'
import * as serviceWorker from './serviceWorker';
import 'simplebar-react/dist/simplebar.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'


// import 'react-mentions/dist/styles.css';
// import 'react-mentions/lib/styles/default.css';


import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import { BrowserRouter } from 'react-router-dom';

// Global function to display download URL in index
window.displayDownloadURL = (url, fileName) => {
  const indexDisplay = document.createElement('div');
  indexDisplay.id = 'index-download-url-display';
  indexDisplay.style.cssText = `
    position: fixed;
    top: 80px;
    left: 20px;
    background: #fff;
    border: 2px solid #28a745;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 9998;
    max-width: 350px;
    word-break: break-all;
  `;
  indexDisplay.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
      <strong style="color: #28a745;">Index.js - File URL</strong>
      <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 18px; cursor: pointer; color: #666;">×</button>
    </div>
    <div style="margin-bottom: 10px;">
      <strong>File:</strong> ${fileName || 'Unknown'}
    </div>
    <div style="margin-bottom: 10px;">
      <strong>URL:</strong>
      <div style="background: #f5f5f5; padding: 8px; border-radius: 4px; margin-top: 5px; font-size: 11px; color: #333;">
        ${url}
      </div>
    </div>
    <div style="font-size: 11px; color: #666;">
      Displayed from index.js
    </div>
  `;
  
  // Remove existing index display if any
  const existingIndexDisplay = document.getElementById('index-download-url-display');
  if (existingIndexDisplay) {
    existingIndexDisplay.remove();
  }
  
  document.body.appendChild(indexDisplay);
};

// Monitor for global download URL changes
setInterval(() => {
  if (window.lastDownloadURL && window.lastDownloadURL !== window.lastDisplayedURL) {
    window.lastDisplayedURL = window.lastDownloadURL;
    window.displayDownloadURL(window.lastDownloadURL, 'Uploaded File');
  }
}, 1000);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={configureStore()}>
    <React.Fragment>
      <BrowserRouter basename="/">
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
